/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_Invalid_CodeInputs */

const de_auth_mfa_error_invalid_code = /** @type {(inputs: Auth_Mfa_Error_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Code. Bitte versuchen Sie es erneut.`)
};

/** @type {(inputs: Auth_Mfa_Error_Invalid_CodeInputs) => LocalizedString} */
const en_auth_mfa_error_invalid_code = de_auth_mfa_error_invalid_code;

/**

* @param {Auth_Mfa_Error_Invalid_CodeInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_invalid_code = /** @type {((inputs?: Auth_Mfa_Error_Invalid_CodeInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_Invalid_CodeInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_invalid_code(inputs)
	return en_auth_mfa_error_invalid_code(inputs)
});